// MRS Studios — Header: scroll state, mega menu, mobile nav, cart trigger
(function () {
  'use strict';

  var header = document.getElementById('mrs-header');
  var hamburger = document.getElementById('mrs-hamburger');
  var mobileNav = document.getElementById('mrs-mobile-nav');
  var mobileClose = document.getElementById('mrs-mobile-close');
  var cartTrigger = document.getElementById('mrs-cart-trigger');
  var cartDrawer = document.getElementById('mrs-cart-drawer');
  var cartClose = document.getElementById('mrs-cart-close');
  var overlay = document.getElementById('mrs-overlay');

  // --- Scroll: transparent → solid ---
  var scrollThreshold = 60;
  var ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.scrollY > scrollThreshold) {
          header.classList.add('mrs-header--scrolled');
        } else {
          header.classList.remove('mrs-header--scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  if (header) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // set initial state
  }

  // --- Mobile nav ---
  function openMobileNav() {
    mobileNav.classList.add('open');
    mobileNav.setAttribute('aria-hidden', 'false');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);

  // --- Cart drawer ---
  function openCart() {
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    window.MrsCart && window.MrsCart.render();
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', function () {
    closeMobileNav();
    closeCart();
  });

  // --- Mega menu: hover with delay ---
  var megaItems = document.querySelectorAll('.mrs-header__nav-item--has-mega');
  var megaCloseTimer;

  megaItems.forEach(function (item) {
    var mega = item.querySelector('.mrs-mega');
    if (!mega) return;

    item.addEventListener('mouseenter', function () {
      clearTimeout(megaCloseTimer);
      document.querySelectorAll('.mrs-mega').forEach(function (m) { m.classList.remove('open'); });
      mega.classList.add('open');
    });
    item.addEventListener('mouseleave', function () {
      megaCloseTimer = setTimeout(function () { mega.classList.remove('open'); }, 120);
    });
    mega.addEventListener('mouseenter', function () { clearTimeout(megaCloseTimer); });
    mega.addEventListener('mouseleave', function () {
      megaCloseTimer = setTimeout(function () { mega.classList.remove('open'); }, 120);
    });
  });

  // Expose openCart for add-to-bag buttons
  window.MrsHeader = { openCart: openCart };
})();
